import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from 'react-router/dom'
import { AuthProvider } from '@/auth/AuthContext'
import { TenantAuthProvider } from '@/auth/TenantAuthContext'
import { Toaster } from '@/components/ui/toast'
import { ThemeProvider } from '@/theme/ThemeProvider'
import { initSentry, reportUncaughtError } from '@/observability/sentry'
import { router } from '@/router'
import '@/index.css'

/**
 * A single QueryClient for the app. `retry: 1` keeps failed reads from hammering
 * the API, and a short `staleTime` is set per-query in the hooks.
 */
initSentry()

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('Root element #root was not found in index.html')
}

createRoot(rootElement, { onUncaughtError: reportUncaughtError }).render(
  <StrictMode>
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <TenantAuthProvider>
            <RouterProvider router={router} />
          </TenantAuthProvider>
        </AuthProvider>
      </QueryClientProvider>
      <Toaster />
    </ThemeProvider>
  </StrictMode>,
)
